import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const routeTransitionAnimations = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true },
    ),

    group([
      query(':leave', [animate('150ms ease-out', style({ opacity: 0, transform: 'translateX(-20px)' }))], { optional: true }),

      query(
        ':enter',
        [style({ opacity: 0, transform: 'translateX(20px)' }), animate('150ms 50ms ease-in', style({ opacity: 1, transform: 'translateX(0)' }))],
        { optional: true },
      ),
    ]),
  ]),
]);
